import styled from "styled-components";
import { Balance } from "../components/Balance/Balance";
import { PaymentList } from "../components/PaymentList/PaymentList";

export const Home = () => {
	return (
		<StyledComponent>
			<Balance />
			<PaymentList />
		</StyledComponent>
	);
};

const StyledComponent = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1rem;
`;
